import { createSelector } from 'reselect'

import { RootState } from 'redux/types'

import { MyProfileState, Profile } from './types'

const getState = (state: RootState): MyProfileState => state.myProfile

const getProfileState = createSelector<RootState, MyProfileState, MyProfileState['profile']>(
  getState,
  (state: MyProfileState) => state.profile,
)

const getProfileUsername = createSelector<RootState, Profile | undefined, string>(
  getProfileState,
  (profile: Profile) => profile?.userName,
)

const getProfileImage = createSelector<RootState, Profile | undefined, string>(
  getProfileState,
  (profile: Profile) => profile?.image,
)

const getProfileId = createSelector<RootState, Profile | undefined, string>(
  getProfileState,
  (profile: Profile) => profile?.id,
)

const getProfileType = createSelector<RootState, Profile | undefined, string>(
  getProfileState,
  (profile: Profile) => profile?.type,
)

const getIsProfileLoading = createSelector<RootState, MyProfileState, boolean>(
  getState,
  (state: MyProfileState) => state.isProfileLoading,
)

const getIsProfileLoaded = createSelector<RootState, MyProfileState, boolean>(
  getState,
  (state: MyProfileState) => state.isProfileLoaded,
)

const getIsProfileLoadingFail = createSelector<RootState, MyProfileState, boolean>(
  getState,
  (state: MyProfileState) => state.isProfileLoadingFailed,
)

const getIsUploadImageLoading = createSelector<RootState, MyProfileState, boolean>(
  getState,
  (state: MyProfileState) => state.isUploadingImageLoading,
)

const getHasUploadingImageFailed = createSelector<RootState, MyProfileState, boolean>(
  getState,
  (state: MyProfileState) => state.hasUploadingImageFailed,
)

const getHasUploadingImageSucceeded = createSelector<RootState, MyProfileState, boolean>(
  getState,
  (state: MyProfileState) => state.hasUploadingImageSuccess,
)

const getNotifications = createSelector<RootState, MyProfileState, MyProfileState['notifications']>(
  getState,
  (state: MyProfileState) => state.notifications,
)

export default {
  getProfileImage,
  getProfileState,
  getProfileUsername,
  getHasUploadingImageFailed,
  getHasUploadingImageSucceeded,
  getIsProfileLoaded,
  getIsProfileLoading,
  getIsProfileLoadingFail,
  getProfileId,
  getProfileType,
  getIsUploadImageLoading,
  getNotifications,
}
